import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Only import PT synchronously (fallback/default); load others on demand
import pt from './locales/pt.json';

const loadLocale = async (lng: string) => {
  switch (lng) {
    case 'en':
      return (await import('./locales/en.json')).default;
    case 'es':
      return (await import('./locales/es.json')).default;
    default:
      return pt;
  }
};

// Detect language without importing the heavy LanguageDetector synchronously
const detectLanguage = (): string => {
  try {
    const stored = localStorage.getItem('i18nextLng');
    if (stored) return stored.split('-')[0];
  } catch { /* ignore */ }
  const nav = navigator.language?.split('-')[0];
  return nav || 'pt';
};

const detectedLng = detectLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
    },
    lng: detectedLng === 'pt' ? 'pt' : undefined,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
  });

// Load detected language if not PT
if (detectedLng && detectedLng !== 'pt') {
  loadLocale(detectedLng).then((translations) => {
    i18n.addResourceBundle(detectedLng, 'translation', translations, true, true);
    i18n.changeLanguage(detectedLng);
  });
}

// Load translations when language changes
i18n.on('languageChanged', async (lng) => {
  const baseLng = lng.split('-')[0];
  if (baseLng !== 'pt' && !i18n.hasResourceBundle(baseLng, 'translation')) {
    const translations = await loadLocale(baseLng);
    i18n.addResourceBundle(baseLng, 'translation', translations, true, true);
    i18n.changeLanguage(baseLng);
  }
  // Persist choice
  try { localStorage.setItem('i18nextLng', baseLng); } catch { /* ignore */ }
});

export default i18n;
